import { Route } from 'types/route.type';

import { routes as bestMixFeeds } from './features/best-mix-feeds/routes';
import { routes as customers } from './features/customers/routes';
import { routes as manualFeeds } from './features/manual-feeds/routes';
import { routes as nutrients } from './features/nutrients/routes';
import { routes as plants } from './features/plants/routes';

export const routes: Route[] = [...bestMixFeeds, ...plants, ...nutrients, ...customers, ...manualFeeds];
